<template>
	<div class="seomain">
	  <st-header
	    title="报价"
	    :back-able="false"
	  >
	  </st-header>
		<div v-if="otherQuoLen" class="" id="tip" style="width: 32px;height: 32px;border-radius: 50%;position: fixed;z-index: 5;font-size: 24px;text-align: center;top: 70px;right: 12px;">
			<van-icon name="chat-o" :badge="otherQuoLen" @click="otherQuoShow = true;" />
		</div>
		
		<div class="st-form-content">
			<div v-if="!formData.id">询价单不存在，或已被删除</div>
			<div v-else-if="err" style="text-align: center;">{{ err }}</div>
		  <st-form ref="form" v-else>
		    <!-- <div class="st-form-title">基本信息</div> -->
				<div class="info">
					<p>品牌：{{ formData.brand }}</p>
					<p>型号: {{ formData.model }}</p>
					<p>数量: {{ formData.quantity }}</p>
					<p>目标价: {{ formData.targetPrice }}</p>
					<p>币种: {{ formData.sCurrency }}</p>
					<p>客户: {{ formData.customer }}</p>
					<p>DC: {{ formData.sDC }}</p>
					<p>交期: {{ formData.sSubmitDay }}</p>
					<p>F/W要求: {{ formData.FW }}</p>
					<p>COO要求: {{ formData.COO }}</p>
					<p>包装要求: {{ formData.pack }}</p>
					<p>备注: {{ formData.sRemark }}</p>
				</div>
		    <div class="st-form-group">
					<div v-if="formData.edit_time_text" style="width: 100%;text-align: center;font-size: 14px;margin-top: 7px;position: relative;bottom: -5px;color: #179ce5;z-index: 9;">询价更新 <span style="font-size: 12px;">{{ formData.edit_time_text }}</span></div>
					<van-cell-group inset>
						<st-form-item key="quo_model" label="型号" prop="quo_model" :required="true" v-if="formData.model_arr && formData.model_arr.length > 1">
							<st-select
							  v-model="formData.quo_model"
								:defText="formData.quo_model"
							  name="型号"
							  placeholder="请选择型号"
							  :options="formData.model_arr"
								:clearable="true"
								:filterable="false"
							>
							</st-select>
						</st-form-item>
						
							<st-form-item key="amount" label="报价" prop="amount">
								<van-field
									class="st-form-item-input"
									v-model="formData.amount"
									name="报价"
									label=""
									placeholder="请填写报价"
									type="number"
								/>
							</st-form-item>
							
							<st-form-item key="currency" label="币种" prop="currency" :required="true">
								<st-select
								  v-model="formData.quo_currency"
									:defText="formData.quo_currency"
								  name="币种"
								  placeholder="请选择币种"
								  :options="$option['getCrmCurrency']"
									:clearable="true"
									:filterable="false"
								>
								</st-select>
							</st-form-item>
							
							<st-form-item key="quo_num" label="数量" prop="quo_num">
								<van-field
									class="st-form-item-input"
									v-model="formData.quo_num"
									name="报价"
									label=""
									placeholder="请填写报价"
									type="number"
								/>
							</st-form-item>
							
							<st-form-item key="dc" label="DC" prop="dc">
								<div v-for="(item, i) in formData.dc">
									<st-select
									  v-model="formData.dc[i]"
										:defText="formData.dc[i]"
									  name="DC"
									  placeholder="请选择DC"
									  :options="$option['getCrmDc']"
										:clearable="true"
										:filterable="false"
										class="dc-select"
									>
									</st-select> 
									<span @click="delDc(i)"><van-icon name="delete" style="color: red;"/></span>	
								</div>
								<div class="new-dc" @click="newDc">+</div>
							</st-form-item>
							
							<st-form-item key="submitDay" label="交期" prop="submitDay">
								<st-select
								  v-model="formData.submitDay"
									:defText="formData.submitDay"
								  name="交期"
								  placeholder="请选择交期"
								  :options="$option['getCrmSubmitDay']"
									:clearable="true"
									:filterable="false"
								>
								</st-select> 
							</st-form-item>
							
							<st-form-item key="remark" label="备注" prop="remark">
								<van-field
									class="st-form-item-input"
									v-model="formData.remark"
									name="备注"
									label=""
									placeholder="请填写备注"
								/>
							</st-form-item>
					</van-cell-group>
				</div>
				
				<div style="margin: 16px;" class="form-submit-button">
				  <van-button round block type="primary"  @click="onSubmit">
				    提交
				  </van-button>
				</div>
				<div v-if="has_quo" id="qsign">已报价</div>
			</st-form>
			
		</div>
		<my-quote :show.sync="otherQuoShow" v-if="otherQuoShow" :quote-data="formData.otherQuo"/>
	</div>
</template>

<script>
import StFileUpload from "@/components/FileUpload.vue";
import StSelect from "@/components/Select.vue";
import StDate from "@/components/Date.vue";
import StHeader from "@/components/layout/Header.vue";
import StForm from "@/components/form.vue";
import StFormItem from "@/components/formItem.vue";
import myQuote from "./my.vue";

export default {
  components: {
    'st-file-upload': StFileUpload,
    'st-select': StSelect,
    "st-header": StHeader,
    "st-form-item": StFormItem,
		StForm,
		StDate,
		myQuote
  },
  props: {},
  data() {
    return {
      formRule: {},
      formData: {
				brand: '',
				modeljson: [],
				dc: [''],
				attachment: [],
				date: this.$formatDate(new Date(), "yyyy-MM-dd"),
				otherQuo: [],
      }, 
      loading: false,
      actField: '',
      actOptions: [],
			err: '',
			has_quo: false,
			otherQuoShow: false,
			otherQuoLen: 0,
    };
  },
  watch: {},
	computed: {},
  created() {
    this.init();
    window.h5sdk && window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "添加采购订单" });
    });
  },
  mounted() {},

  methods: {
    init() {
			let query = this.$route.params;
			if (query.id) this.formData.id = query.id;
			this.getUpdateData();
		},
		
		// 再建一个DC
		newDc() {
			this.formData.dc.push('');
		},
		delDc(i) {console.log(11);
			this.formData.dc.splice(i, 1);
			
		},
		// 获取编辑需要显示的数据
		getUpdateData() {
			if (this.formData.id) {
				this.$post(`${this.$api.stCrmQuotationInfo}`, {id: this.formData.id}).then((res) => {
					if (res.code == 1) {
						let data = res.data;
						
						this.formData = data;
						if (data.amount > 0) {
							this.has_quo = true;
						}
						
						if (!this.formData.quo_currency) {
							this.$option['getCrmCurrency'](this, {}).then(res => {
								let sCurrency = res.find((item) => {
									return item.text == data.sCurrency
								})
								this.$set(this.formData, ['quo_currency'], sCurrency['value'])
							})
						}
						this.otherQuoLen = this.formData.otherQuo.length;
				
					} else {
						this.err = res.msg;
					}
					
				}).catch((err) => {
					this.err = '意料外的错误，请稍后重试';
					console.log('quotation/index', err);
				});
			} else {}
		},

    // 提交表单
    onSubmit() {
     this.$refs.form.validater.valid((isValid, lastError) => {
        if (!isValid) {
          this.$toast.fail('表单异常：' + lastError);
        }
      });
			
      let formData = JSON.parse(JSON.stringify(this.formData));
			this.$post(this.$api.stCrmQuotationSave, formData).then((res) => {
				if (res.code !== 1) {
					this.$toast.fail(res.msg ? res.msg : '报价异常');
				} else {
					this.has_quo = true;
					this.$toast.success("报价成功");
				}
			});
      
    },
		
  },
};
</script>

<style lang="scss" scoped>
.info {
	background: white;
	padding: 10px 16px;
	p {
		margin: 12px 0px;
	}
}

.new-dc {
	text-align: center;
	font-size: 24px;
	background: #80c33b;
	color: white;
	margin-top: 4px;
	border-radius: 5px;
}
.van-icon-delete {
	color: red;
	font-size: 24px;
	margin-left: 5px;
	line-height: 40px;
}
.dc-select {
	display: inline-block;
	width: 90%;	
}

#qsign {
		position: absolute;
		top: 90px;
		font-size: 28px;
		border: 1px solid #08b60c;
		width: 110px;
		height: 110px;
		text-align: center;
		line-height: 110px;
		border-radius: 50%;
		color: #10e616;
		transform: rotate(45deg);
		right: 32px;
		opacity: 0.4;
}


	
.st-form-content {
	position: relative;
  margin: 18px 15px;
	form {
		overflow: hidden;
	}
	
  .st-form-title {
    border-radius: 5px 5px 0px 0px;
    padding: 20px 21px;
    font-size: 20px;
    background-color: rgb(207, 212, 217);

    .st-van-btn-info {
      float: right;
    }
  }
  .st-form-group {
    background-color: white;
    margin-bottom: 20px;
    position: relative;
    overflow: hidden;
		padding-bottom: 16px;
		border-radius: 5px;
		// padding-bottom: 60px;
    
    .st-van-filed-label-imp {
      color: rgb(231, 91, 124);
    }

    .st-van-filed-label {
      margin: 15px 6px 8px; 
    }
    
    .van-field {
      box-shadow: inset 0 0 0 2px rgb(223,223,223);
      border-radius: 5px;
    }

		.data-size {
			display: flex;
			.span-x {
				line-height: 44px;
				padding: 0px 2px;
			}
		}
  }

	// .form-submit-button {
	// 		position: fixed;
	// 		width: 83vw;
	// 		bottom: 0px;
	// 		left: 0px;
	// 		right: 0px;
	// 		margin: 14px auto!important;
 //    }
}

</style>
